const defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
export const globalSettingsIssuesFieldlayoutsSchemesDeleteRoute = {
	name: 'global-settings-issues-fieldlayouts-schemes-delete',
	path: `/secure/admin/DeleteFieldLayoutScheme${defaultSuffix}.jspa`,
};
